<template>
    <div v-if="additionals">
        <div v-if="model && additionals.salaVacinacaoLogada && !!additionals.salaVacinacaoLogada.id">
            <rkm-form
                v-if="model"
                ref="RkmForm"
                show-legend
            >
                <rkm-area
                    title="Dados do paciente"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-input-autocomplete
                                :repository="repositories.paciente"
                                :search-fields="fields.autocomplete.paciente"
                                :text-field="(item) =>  item.cidadao.cns ? `${this.formatCns(item.cidadao.cns)} - ${item.cidadao.nome}` : item.cidadao.nome"
                                :validations="validations.paciente"
                                @select="handlePacienteSelect"
                                label="Nome"
                                v-model="model.paciente"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-input
                                :value="model.paciente && model.paciente.cidadao.sexo.descricao"
                                disabled
                                label="Sexo"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-date-picker
                                :value="model.paciente && model.paciente.cidadao.dataNascimento"
                                disabled
                                label="Data de nascimento"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-input
                                :value="model.paciente && `${model.paciente.cidadao.idade.anos}a, ${model.paciente.cidadao.idade.meses}m e ${model.paciente.cidadao.idade.dias}d`"
                                disabled
                                label="Idade"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="2">
                            <rkm-form-input
                                :value="model.paciente && model.paciente.prontuario"
                                disabled
                                label="Prontuário"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-input
                                :value="model.paciente && model.paciente.cidadao.cns"
                                disabled
                                label="CNS"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-input
                                :value="model.paciente && model.paciente.cidadao.nomeMae"
                                disabled
                                label="Nome da mãe"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-input
                                disabled
                                label="Unidade de saúde"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-input
                                :value="model.paciente && model.paciente.cidadao.domicilio.endereco.logradouro.nome"
                                disabled
                                label="Logradouro"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-input
                                :value="model.paciente && model.paciente.cidadao.domicilio.endereco.numero"
                                disabled
                                label="Número"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-input
                                :value="model.paciente && model.paciente.cidadao.domicilio.endereco.complemento"
                                disabled
                                label="Complemento"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-input
                                :value="model.paciente && model.paciente.cidadao.domicilio.endereco.referencia"
                                disabled
                                label="Ponto de referência"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="4">
                            <rkm-form-input
                                :value="model.paciente && model.paciente.cidadao.domicilio.endereco.logradouro.bairro.nome"
                                disabled
                                label="Bairro"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-input
                                :value="model.paciente && model.paciente.cidadao.domicilio.endereco.logradouro.municipio.nome"
                                disabled
                                label="Município"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-input
                                :value="model.paciente && model.paciente.cidadao.domicilio.endereco.logradouro.municipio.estado.nome"
                                disabled
                                label="Estado"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                <rkm-area
                    title="Dados da aplicação"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-select
                                :disabled="(additionals && !additionals.salaVacinacaoLogada.responsavel)"
                                :options="form.unidades"
                                :validations="validations.unidadeId"
                                @change="handleUnidadeIdDeChange"
                                label="Unidade"
                                show-default-option
                                text-field="nomeFantasia"
                                v-model="model.unidadeId"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-select
                                :disabled="(additionals && !additionals.salaVacinacaoLogada.responsavel)"
                                :options="form.salasVacinacao"
                                :validations="validations.salaVacinacaoId"
                                @change="handleSalaVacinacaoIdChange"
                                label="Local de atendimento"
                                show-default-option
                                text-field="nome"
                                v-model="model.salaVacinacaoId"
                                value-field="id"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="8">
                            <rkm-form-input-autocomplete
                                :disabled="!model.salaVacinacaoId"
                                :repository="repositories.usuario"
                                :request-query-string-params="{ aplicador: true, sala_vacinacao_id: model.salaVacinacaoId }"
                                :search-fields="fields.autocomplete.aplicador"
                                :text-field="(item) =>  item.cidadaoCns ? `${this.formatCns(item.cidadaoCns)} - ${item.cidadaoNome}` : item.cidadaoNome"
                                :validations="validations.aplicador"
                                label="Aplicador"
                                v-model="model.aplicador"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-date-picker
                                :disabled="!model.salaVacinacaoId"
                                :max-date="others.moment(additionals.dataAtual, 'YYYY-MM-DD').format('DD/MM/YYYY')"
                                :validations="validations.dataAplicacao"
                                label="Data"
                                right
                                v-model="model.dataAplicacao"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="8">
                            <rkm-form-input
                                :value="inputVacinaValue"
                                disabled
                                label="Vacina"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-select
                                :disabled="!model.salaVacinacaoId"
                                :options="form.lotes"
                                :validations="validations.lote"
                                @change="handleLoteChange"
                                label="Lote"
                                show-default-option
                                v-model="model.lote"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="3">
                            <rkm-form-select
                                :disabled="!model.lote"
                                :options="form.produtores"
                                :validations="validations.produtorId"
                                label="Produtor"
                                show-default-option
                                text-field="nome"
                                v-model="model.produtorId"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-select
                                :options="form.gruposAtendimento"
                                :validations="validations.grupoAtendimentoId"
                                label="Grupo de atendimento"
                                show-default-option
                                text-field="nome"
                                v-model="model.grupoAtendimentoId"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-select
                                :disabled="!model.doseId"
                                :options="form.estrategias"
                                :validations="validations.estrategiaId"
                                @change="handleEstrategiaChange"
                                label="Estratégia"
                                show-default-option
                                text-field="nome"
                                v-model="model.estrategiaId"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-select
                                :disabled="!model.paciente"
                                :options="form.doses"
                                :validations="validations.doseId"
                                label="Dose"
                                show-default-option
                                text-field="nome"
                                v-model="model.doseId"
                                value-field="id"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="4">
                            <rkm-form-select
                                :disabled="!model.vacina || model.estrategiaId !== 2"
                                :validations="validations.motivoId"
                                label="Motivo vacina especial"
                                show-default-option
                                text-field="nome"
                                v-model="model.motivoId"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col cols="8">
                            <rkm-form-checkbox
                                :disabled="disabledcomunicanteHanseniase"
                                :label="false"
                                inline
                                v-model="model.comunicanteHanseniase"
                            >
                                Comunicante de Hanseníase
                            </rkm-form-checkbox>

                            <rkm-form-checkbox
                                :disabled="!model.paciente || model.paciente && model.paciente.cidadao.sexoId === enums.sexo.MASCULINO"
                                :label="false"
                                inline
                                v-model="model.gestante"
                            >
                                Gestante
                            </rkm-form-checkbox>

                            <rkm-form-checkbox
                                :disabled="disabledPuerpera"
                                :label="false"
                                inline
                                v-model="model.puerpera"
                            >
                                Puerpera
                            </rkm-form-checkbox>

                            <rkm-form-checkbox
                                :label="false"
                                inline
                                v-model="model.imunizacaoAdvertida"
                            >
                                Imunização advertida
                            </rkm-form-checkbox>

                            <rkm-form-checkbox
                                :disabled="disabledViajante"
                                :label="false"
                                inline
                                v-model="model.viajante"
                            >
                                Viajante
                            </rkm-form-checkbox>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-form-textarea
                                :validations="validations.observacao"
                                label="Observação"
                                rows="4"
                                v-model="model.observacao"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-form>
        </div>

        <rkm-alert v-else color="warning">
            A unidade logada não é uma sala de vacinação ou está desativada, favor cadastra-la para efetuar um registro de vacinação.
        </rkm-alert>
    </div>
</template>

<script>
// Enums.
import parametrizacaoDescricaoVacina from '@/enums/imunizacao/parametrizacaoDescricaoVacina'
import sexo from '@/enums/cadastro/cidadao/sexo'
import vacina from '@/enums/cadastro/vacina'
import subclassificacao from '@/enums/cadastro/paciente/subclassificacao'

// Mixins.
import { error, formats, repository, stringCase } from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import { mapGetters, mapActions } from 'vuex'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {
            return {
                autocomplete: {
                    aplicador: [
                        { key: 'cadastroCidadao.nome', searchable: true },
                    ],
                    paciente: [
                        { key: 'cidadao.nome', searchable: true },
                    ],
                },
            }
        },
        validations() {
            return {
                paciente: { required: true },
                unidadeId: { required: true },
                salaVacinacaoId: { required: true },
                aplicador: { required: true },
                dataAplicacao: { required: true },
                vacina: { required: true },
                lote: { required: true },
                produtorId: { required: true },
                grupoAtendimentoId: { required: true },
                doseId: { required: true },
                estrategiaId: { required: true },
                motivoId: { required: this.model.estrategiaId === 2 },
                observacao: { min: 3, max: 5000 },
            }
        },
        inputVacinaValue() {
            let value = null

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    value = this.model.vacina.abreviacao
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    value = this.model.vacina.sigla
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    value = this.model.vacina.siglaNome
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    value = this.model.vacina.siglaAbreviacao
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    value = this.model.vacina.abreviacaoNome
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    value = this.model.vacina.siglaAbreviacaoNome
                    break;

                default:
                    value = this.model.vacina.nome
                    break;
            }

            return value
        },
        disabledcomunicanteHanseniase() {
            if (this.model && this.model.vacina && this.model.vacina.id === this.enums.vacina.BCG) {
                return false
            }

            return true
        },
        disabledPuerpera() {
            const salaVacinacao = this.form.salasVacinacao && this.form.salasVacinacao.find(salaVacinacao => salaVacinacao.id === this.model.salaVacinacaoId)

            if (!this.model.salaVacinacaoId) {
                return true
            }
            else if (this.model.paciente && this.model.paciente.cidadao.sexo.id === this.enums.sexo.MASCULINO) {
                return true
            }
            else if (salaVacinacao && !salaVacinacao.criaFichaAb) {
                return true
            }

            return false
        },
        disabledViajante() {
            const salaVacinacao = this.form.salasVacinacao && this.form.salasVacinacao.find(salaVacinacao => salaVacinacao.id === this.model.salaVacinacaoId)

            if (salaVacinacao && !salaVacinacao.criaFichaAb) {
                return true
            }

            return false
        },
    },
    created() {
        this.repositories = {
            aplicacaoCampanha: this.getConectaSusRepository('imunizacao.aplicacaoCampanha'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            fichaVacinacao: this.getConectaSusRepository('atencaoBasica.fichaVacinacao'),
        }
    },
    data: () => ({
        additionals: null,
        enums: {
            parametrizacaoDescricaoVacina,
            sexo,
            vacina,
            subclassificacao
        },
        form: null,
        model: null,
        others: { moment },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            const request = {
                campanhaId: this.id,
            }

            this.setLoading()

            this.repositories.aplicacaoCampanha.create(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)

                    this.form.lotes = this.form.lotes.map(lote => {
                        return {
                            text: `${lote.lote} - Val: ${this.others.moment(lote.dataValidadeLote).format('DD/MM/YYYY')}`,
                            value: lote,
                        }
                    })

                    if (this.form.lotes.length > 0) {
                        const selected = this.form.lotes[0]
                        this.model.lote = selected.value

                        this.getProdutores(this.model.salaVacinacaoId, this.model.vacina.id, selected.value.lote, selected.value.dataValidadeLote)
                    }

                    if (this.form.produtores.length === 1) {
                        const selected = this.form.produtores[0]
                        this.model.produtorId = selected.id
                    }

                    this.$emit('loaded', { additionals: this.additionals })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handlePacienteSelect(value) {

            this.setLoading()

            this.repositories.paciente.validCNS(this.camelObjectKeysToSnakeRecursive({pacienteId: value.id}))
                .then(response => {

                    if (!response.data.additionals.cnsValido && response.data.additionals.avisaCnsTemporarioInvalido) {

                        this.showWarningNotification('Paciente com CNS inválido. Registro não permitido.')

                        this.model.paciente = null
                        return false
                    }

                    if (value.subclassificacaoId === this.enums.subclassificacao.TEMPORARIO
                        && response.data.additionals.avisaCnsTemporarioInvalido) {

                            const confirm = async () => {

                                this.model.doseId = null
                                this.model.gestante = false
                                this.model.puerpera = false

                                if (value) {

                                    this.getDoses(this.model.vacina.id, value.id)
                                }

                                return false
                            }

                            const cancel = async () => {

                                this.model.paciente = null
                                return false
                            }

                            const msg = `Paciente com cadastro temporário. Deseja continuar?`

                            this.showConfirmation(msg, confirm, cancel)

                            return false
                    }

                    this.model.doseId = null
                    this.model.gestante = false
                    this.model.puerpera = false

                    if (value) {
                        this.getEstrategias(this.model.vacina.id)
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUnidadeIdDeChange(value) {
            this.form.salasVacinacao = null
            this.form.lotes = null
            this.form.produtores = null
            this.model.salaVacinacaoId = null
            this.model.aplicador = null
            this.model.dataAplicacao = null
            this.model.lote = null
            this.model.produtorId = null
            this.model.comunicanteHanseniase = false
            this.model.puerpera = false
            this.model.viajante = false

            if (value) {
                this.getSalasVacinacao(value)
            }
        },
        handleSalaVacinacaoIdChange(value) {
            this.form.lotes = null
            this.form.produtores = null
            this.model.aplicador = null
            this.model.dataAplicacao = null
            this.model.lote = null
            this.model.produtorId = null
            this.model.comunicanteHanseniase = false
            this.model.puerpera = false
            this.model.viajante = false

            if (value) {
                this.getLotes(value, this.model.vacina.id)
            }
        },
        handleLoteChange(value) {
            this.form.produtores = null
            this.model.produtorId = null

            this.getProdutores(this.model.salaVacinacaoId, this.model.vacina.id, value.lote, value.dataValidadeLote)
        },
        handleEstrategiaChange(value) {
            this.form.doses = null
            this.model.doseId = null

            this.getDoses(this.model.vacina.id, value)
        },
        getSalasVacinacao(unidadeId) {
            const request = {
                listar: 'salas_vacinacao',
                unidadeId: unidadeId,
            }

            this.setLoading()

            this.repositories.aplicacaoCampanha.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.salasVacinacao = Object.assign(response.data)

                    if (this.form.salasVacinacao.length === 1) {
                        const selected = this.form.salasVacinacao[0]
                        this.model.salaVacinacaoId = selected.id

                        this.getLotes(selected.id, this.model.vacina.id)
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getLotes(salaVacinacaoId, vacinaId) {
            const request = {
                listar: 'lotes',
                salaVacinacaoId: salaVacinacaoId,
                vacinaId: vacinaId,
            }

            this.setLoading()

            this.repositories.aplicacaoCampanha.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.lotes = response.data.map(lote => {
                        return {
                            text: `${lote.lote} - Val: ${this.others.moment(lote.dataValidadeLote).format('DD/MM/YYYY')}`,
                            value: lote,
                        }
                    })

                    if (this.form.lotes.length > 0) {
                        const selected = this.form.lotes[0]
                        this.model.lote = selected.value

                        this.getProdutores(salaVacinacaoId, vacinaId, selected.value.lote, selected.value.dataValidadeLote)
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getProdutores(salaVacinacaoId, vacinaId, lote, dataValidadeLote) {
            const request = {
                listar: 'produtores',
                salaVacinacaoId: salaVacinacaoId,
                vacinaId: vacinaId,
                lote: lote,
                dataValidadeLote: dataValidadeLote,
            }

            this.setLoading()

            this.repositories.aplicacaoCampanha.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.produtores = response.data

                    if (this.form.produtores.length === 1) {
                        const selected = this.form.produtores[0]
                        this.model.produtorId = selected.id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getDoses(vacinaId, estrategiaId) {
            this.setLoading()
            this.repositories.fichaVacinacao.getDoses({
                vacina_id: vacinaId,
                estrategia_id: estrategiaId
            })
                .then(response => {
                    this.form.doses = response.data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getEstrategias(vacinaId) {
            this.setLoading()
            this.repositories.fichaVacinacao.getEstrategias({
                vacina_id: vacinaId,
            })
                .then(response => {
                    this.form.estrategias = response.data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleSave(request) {
            this.setLoading()

            this.repositories.aplicacaoCampanha.store(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.showSaveNotification()
                    this.$emit('save', response)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    const request = {
                        pacienteId: this.model.paciente.id,
                        salaVacinacaoId: this.model.salaVacinacaoId,
                        aplicadorId: this.model.aplicador.id,
                        dataAplicacao: this.others.moment(this.model.dataAplicacao).format('DD/MM/YYYY'),
                        vacinaId: this.model.vacina.id,
                        lote: this.model.lote.lote,
                        dataValidadeLote: this.model.lote.dataValidadeLote,
                        produtorId: this.model.produtorId,
                        grupoAtendimentoId: this.model.grupoAtendimentoId,
                        doseId: this.model.doseId,
                        estrategiaId: this.model.estrategiaId,
                        motivoId: this.model.motivoId,
                        campanhaId: this.id,
                        comunicanteHanseniase: this.model.comunicanteHanseniase,
                        gestante: this.model.gestante,
                        puerpera: this.model.puerpera,
                        imunizacaoAdvertida: this.model.imunizacaoAdvertida,
                        viajante: this.model.viajante,
                        observacao: this.model.observacao,
                    }

                    if (this.additionals.parametrizacao.usaUltimoFrasco) {
                        this.showConfirmation(
                            'Ultima aplicação do frasco?',
                            async () => {
                                request.ultimoFrasco = true
                                this.handleSave(request)
                            },
                            async () => {
                                request.ultimoFrasco = false
                                this.handleSave(request)
                            }
                        )
                    } else {
                        request.ultimoFrasco = false
                        this.handleSave(request)
                    }
                })
        },
    },
    mixins: [ error, formats, repository, stringCase ],
    mounted() {
        this.load()
    },
    props: {
        id: { type: [Number, String], default: null },
    },
}
</script>